$(function() {
    $('[name=form_text_64]').mask('+7(999)999-9999');

    $('[name^=form_text_], [name^=form_textarea_], [name^=form_email_]')
        .addClass('form__input form__input--shade')
        .attr('style', '');
});



// WEBPACK FOOTER //
// ./blocks/vacancy/vacancy.js